import styled from 'styled-components'
import { Text, useMatchBreakpoints, Flex } from 'vvs-uikit'
import { useHistory } from 'react-router-dom'
import { VVS_GOTCHI_MAINTENANCE_MODE } from 'config/constants/vvsgotchi'
import { Path } from 'config/constants/paths'
import { useTranslation } from 'contexts/Localization'
import VvsGotchiActionButton from '../ActionButton'

export const storageKey = 'vvsgotchi-live'

export const isHidden = (inactiveBannerKey: string[]) => {
  if (VVS_GOTCHI_MAINTENANCE_MODE) return false
  return inactiveBannerKey.includes(storageKey)
}

export const VvsGotchiPromotionLiveBanner = ({ onCloseClick }) => {
  const { t } = useTranslation()
  const { isTablet, isDesktop } = useMatchBreakpoints()
  const routerHistory = useHistory()

  const imgSrcs = isDesktop
    ? ['Banner_Live_Desktop_bg.png', 'Mole_Face_Desktop.png']
    : isTablet
    ? ['Banner_Live_Tablet_bg.png', 'Mole_Face_Tablet.png']
    : ['Banner_Live_Mobile_bg.png', 'Mole_Face_Mobile.png']

  return (
    <StyledVVSGotchiCard imgSrc={imgSrcs[0]}>
      {!VVS_GOTCHI_MAINTENANCE_MODE && (
        <VisitBtn onClick={() => routerHistory.push(Path.VVS_GOTCHI)}>{t('Play')}</VisitBtn>
      )}
      <StyledTitleWrapper>
        <Text
          color="black"
          maxWidth={['260px', '260px', 'unset']}
          fontSize={['20px', '20px', '20px', '24px']}
          fontWeight="400"
          fontFamily="retroLandMayhem"
        >
          {VVS_GOTCHI_MAINTENANCE_MODE
            ? t('🚧 Maintenance: VVSGotchi (Feb-21st, 6-6:30am UTC)')
            : t('VVSGotchi is Live!')}
        </Text>
        <Text
          color="black"
          fontSize="14px"
          fontWeight="400"
          maxWidth={['260px', '260px', '327px', 'unset']}
          fontFamily="retroLandMayhem"
          pt={2}
        >
          {VVS_GOTCHI_MAINTENANCE_MODE
            ? t('VVSGotchi page will be unavailable during this time.')
            : t('Go on quests and power up your Miner Moles!')}
        </Text>
      </StyledTitleWrapper>
      {!VVS_GOTCHI_MAINTENANCE_MODE && (
        <>
          <StyledImage src={`/images/vvsGotchi/${imgSrcs[1]}`} alt="" />
          <CloseBtn onClick={onCloseClick} />
        </>
      )}
    </StyledVVSGotchiCard>
  )
}

const VisitBtn = styled(VvsGotchiActionButton)`
  position: absolute;
  width: 32%;
  height: 24%;
  left: 7%;
  bottom: 9%;

  color: black;

  ${({ theme }) => theme.mediaQueries.sm} {
    position: static;

    width: 18%;
    height: 55%;
    margin-left: 3%;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    width: 10%;
  }
`

const CloseBtn = styled.div`
  cursor: pointer;
  position: absolute;
  background: transparent;
  background-image: url('/images/vvsMinerMole/close_button.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
  top: 15%;
  right: 6%;

  ${({ theme }) => theme.mediaQueries.sm} {
    top: 50%;
    right: 2%;
    transform: translate(0, -50%);
  }
`

const StyledVVSGotchiCard = styled(Flex)<{ imgSrc: string }>`
  border-radius: ${({ theme }) => theme.radii.card};
  width: 100%;
  padding: 0px;
  max-width: 1200px;

  background: url('/images/vvsGotchi/${({ imgSrc }) => imgSrc}');
  background-size: cover;
  position: relative;
  margin-top: 10px;
  margin-bottom: 20px;
  margin-left: 30px;
  margin-right: 30px;

  height: 238px;
  ${({ theme }) => theme.mediaQueries.sm} {
    align-items: center;
    height: 104px;
  }
`
const StyledImage = styled.img`
  position: absolute;
  width: 211px;
  height: auto;
  bottom: 0;
  right: 0;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: none;
    margin-right: 50px;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    display: block;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    width: 497px;
    margin-right: -10px;
  }
  ${({ theme }) => theme.mediaQueries.xl} {
    margin-right: 87px;
  }
`
const StyledTitleWrapper = styled(Flex)`
  margin-left: 18px;
  margin-top: 18px;
  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 30px;
    margin-top: 0;
  }

  flex-direction: column;
`
